import React, { useEffect, useState } from "react";
import { useLang } from "../i18n/LanguageContext";
import useSEO from "../hooks/useSEO";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import BookingEngine from "../components/BookingEngine";

// category filter passed as prop
const Products = ({ category, categories, titleKey }) => {
  const { lang, tr } = useLang();
  const [products, setProducts] = useState([]);
  useSEO({ title: `MobiRider — ${tr.products.title}`, description: tr.products.subtitle, lang });
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  const cats = categories || (category ? [category] : null);
  const list = cats ? products.filter((p) => cats.includes(p.category)) : products;
  const heading = titleKey ? tr.nav[titleKey] : tr.products.title;

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-ink tracking-tight">{heading}</h1>
      <p className="text-xl text-ink-muted mt-4 max-w-2xl">{tr.products.subtitle}</p>
      <div className="my-10"><BookingEngine /></div>
      <div className="grid gap-7 md:grid-cols-3" data-testid="products-grid">
        {list.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
};

export default Products;
